import styled from 'styled-components';

import { COLOR } from 'constants/color';

export const ContainerSection = styled.div`
  border: 1px solid ${COLOR.neutralTrans['neutralTrans-15']};
  border-radius: 16px;
  width: 100%;
  padding: 16px;
  margin-bottom: 24px;
`;
